import React from "react";
import { Breadcrumb } from "../components/Breadcrumb";

export const StatisticsPage = () => (
  <>
    <Breadcrumb items={[{ text: "Statistics", link: "/statistics" }]} />
  </>
);
